/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PeopleContact } from '../models/people-contact';
import { Envelope } from '../models/envelope';
@Injectable({
  providedIn: 'root',
})
class ContactService extends __BaseService {
  static readonly ContactGetAllPath = '/api/contract';
  static readonly ContactUpdatePath = '/api/contract';
  static readonly ContactCreatePath = '/api/contract';
  static readonly ContactGetPath = '/api/contract/{id}';
  static readonly ContactDeletePath = '/api/contract/{id}';
  static readonly ContactGet_1Path = '/api/contract/email/{emailAddress}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  ContactGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<PeopleContact[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/contract`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PeopleContact[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  ContactGetAll(): __Observable<Envelope<PeopleContact[]>> {
    return this.ContactGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<PeopleContact[]>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  ContactUpdateResponse(entity: PeopleContact): __Observable<__StrictHttpResponse<Envelope<PeopleContact>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/contract`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PeopleContact>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  ContactUpdate(entity: PeopleContact): __Observable<Envelope<PeopleContact>> {
    return this.ContactUpdateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<PeopleContact>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  ContactCreateResponse(entity: PeopleContact): __Observable<__StrictHttpResponse<Envelope<PeopleContact>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/contract`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PeopleContact>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  ContactCreate(entity: PeopleContact): __Observable<Envelope<PeopleContact>> {
    return this.ContactCreateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<PeopleContact>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  ContactGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<PeopleContact>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/contract/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PeopleContact>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  ContactGet(id: number): __Observable<Envelope<PeopleContact>> {
    return this.ContactGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<PeopleContact>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  ContactDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/contract/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  ContactDelete(id: number): __Observable<Envelope<any>> {
    return this.ContactDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }

  /**
   * @param emailAddress undefined
   * @return OK
   */
  ContactGet_1Response(emailAddress: string): __Observable<__StrictHttpResponse<Envelope<PeopleContact>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/contract/email/${encodeURIComponent(emailAddress)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PeopleContact>>;
      })
    );
  }
  /**
   * @param emailAddress undefined
   * @return OK
   */
  ContactGet_1(emailAddress: string): __Observable<Envelope<PeopleContact>> {
    return this.ContactGet_1Response(emailAddress).pipe(
      __map(_r => _r.body as Envelope<PeopleContact>)
    );
  }
}

module ContactService {
}

export { ContactService }
